<div class="krk-list-container">
  <button [disabled]="!(userPermissions | async).krk.write" mat-stroked-button color="primary" class="add-button" (click)="addKrk()"><mat-icon>add</mat-icon> Dodaj KRK</button>

  <table mat-table [dataSource]="dataSource">

    <!-- Position Column -->
    <ng-container matColumnDef="name">
      <th mat-header-cell *matHeaderCellDef> Nazwa </th>
      <td mat-cell *matCellDef="let element">
        <a class="default-link" [routerLink]="['/krk/szczegoly', element.uuid]">KRK {{element.ofwca.fullName}}</a>
      </td>
    </ng-container>

    <ng-container matColumnDef="activeFee">
      <th mat-header-cell *matHeaderCellDef>  Aktywna opłata </th>
      <td mat-cell *matCellDef="let element" >
        <mat-slide-toggle
          [disabled]="!(userPermissions | async).krk.write || updateInProgress"
          [checked]="element.activeFee" (change)="agreedToDeregisterChanged(
            $event,
            element
        )"></mat-slide-toggle>
      </td>
    </ng-container>

    <ng-container matColumnDef="status">
      <th mat-header-cell *matHeaderCellDef> Status </th>
      <td mat-cell *matCellDef="let element">
        <button mat-raised-button [ngClass]="element.status.color + '-button'">{{element.status.name}}</button>
      </td>
    </ng-container>

    <ng-container matColumnDef="activeTo">
      <th mat-header-cell *matHeaderCellDef> Data ważności </th>
      <td mat-cell *matCellDef="let element">
        {{element.activeTo | date:'y-MM-dd'}}
      </td>
    </ng-container>

    <ng-container matColumnDef="daysLeft">
      <th mat-header-cell *matHeaderCellDef> Pozostało dni </th>
      <td mat-cell *matCellDef="let element">
        {{element.daysLeft}}
      </td>
    </ng-container>

    <ng-container matColumnDef="payer">
      <th mat-header-cell *matHeaderCellDef> Kto ponosi opłatę </th>
      <td mat-cell *matCellDef="let element">
        {{element.payer?.name}}
      </td>
    </ng-container>

    <ng-container matColumnDef="actions">
      <th mat-header-cell *matHeaderCellDef></th>
      <td mat-cell *matCellDef="let element">
        <button mat-icon-button [matMenuTriggerFor]="menu"><mat-icon>expand_more</mat-icon></button>
        <mat-menu #menu="matMenu" xPosition="before">
          <button [disabled]="!(userPermissions | async).document.write" mat-menu-item (click)="addDocument(element)">Dodaj dokument</button>
          <button [disabled]="!(userPermissions | async).krk.delete" mat-menu-item (click)="deleteKrk(element)">Usuń</button>
        </mat-menu>
      </td>
    </ng-container>

    <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
    <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
  </table>

  <mat-paginator [pageSizeOptions]="[10, 20, 50,]"></mat-paginator>
</div>
